import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'services/storage/storage.service';
import { Strings } from 'src/app/common/utility/string/string';
// import { StorageService } from '../storage/storage.service';

/** 
 * Service to cache routes when redirected to login or page refresh
 */
@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  public clearRouteCache(): void {
    StorageService.Route = null;
  }

  public get cachedRoute(): string {
    return StorageService.Route ?? Strings.Empty;
  }

  public set cachedRoute(value) {
    StorageService.Route = value;
  }

  public navigate(route: string | null = null): void {
    this.router.navigate(['/', route ?? this.cachedRoute]);
  }

  constructor(
    private router: Router
  ) { }

}